/**
 * De periodekeuze los van het schermwerk: welke waarde bij welke soort hoort.
 *
 * Staat hier en niet bij `PeriodeKiezer`, omdat een `.tsx` alleen componenten
 * hoort te exporteren (fast refresh), en omdat dit de kant is die te testen valt.
 */

/** `altijd` is alles bij elkaar: geen periode, dus ook geen keuzelijst ernaast. */
export type PeriodeKeuze = 'maand' | 'jaar' | 'altijd';

/** De sleutel waarmee de server "alles bij elkaar" leest. */
export const ALLES = 'alles';

export interface Beschikbaar {
  maanden: string[];
  jaren: string[];
}

/**
 * Welke waarde bij de nieuwe soort hoort. Een gekozen waarde hoort bij één van
 * de soorten: "2026-08" is geen geldig jaar en "2026" geen geldige maand, dus
 * bij het wisselen moet er een andere komen.
 *
 * Van maand naar jaar is dat het jaar eromheen, van jaar naar maand de nieuwste
 * maand binnen dat jaar. `undefined` betekent: laat de server kiezen, en dat is
 * wat er overblijft zolang de kiezer nog geen lijst heeft.
 */
export function periodeVoorSoort(
  soort: PeriodeKeuze,
  huidig: string | undefined,
  beschikbaar: Beschikbaar | undefined,
): string | undefined {
  if (soort === 'altijd') return ALLES;

  const jaar = huidig?.slice(0, 4);
  if (soort === 'jaar') return jaar ?? beschikbaar?.jaren[0];

  const maanden = beschikbaar?.maanden ?? [];
  return (jaar ? maanden.filter((m) => m.startsWith(jaar)) : maanden)[0] ?? maanden[0];
}
